import "./styles.scss";
import { useContext } from "react";
import { BsFillFileEarmarkSpreadsheetFill } from "react-icons/bs";
import { FaCloudUploadAlt, FaChevronRight } from "react-icons/fa";
import { BsClipboard2DataFill } from "react-icons/bs";
import { DiDotnet } from "react-icons/di";
import {
    MdDashboard,
    MdAnalytics,
    MdSettings,
    MdPerson,
    MdNotifications,
    MdLogout,
    MdClose
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Context } from "../../context/Contex";

export default function BarMenu() {
    const {
        isOpen,
        setIsOpen,
        activeItem,
        setActiveItem,
        loggedInUser,
        unreadCount,
        router: routeMap,
        permissions,
        permissionsLoading,
        hasRoutePermission
    } = useContext(Context);

    const navigate = useNavigate();

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    const handleItemClick = (itemId) => {
        setActiveItem(itemId);
        closeMenu();
        if (routeMap[itemId]?.path) {
            navigate(routeMap[itemId].path);
        }
    };

    const renderMenuItem = (itemId, icon, label, badge = null) => {
        if (!hasRoutePermission(itemId)) return null;
        

        return (
            <div
                key={itemId}
                className={`menu-item ${activeItem === itemId ? 'active' : ''}`}
                onClick={() => handleItemClick(itemId)}
            >
                {icon}
                <span>{label}</span>
                {badge}
            </div>
        );
    };

    if (permissionsLoading) {
        return (
            <div id="BarMenu">
                <nav className="bar-menu open">
                    <div className="menu-logo">
                        <div className="logo-wrapper">
                            <DiDotnet />
                        </div>
                        <span className="logo-text">Carregando...</span>
                    </div>
                </nav>
            </div>
        );
    }

    return (
        <div id="BarMenu">
            {!isOpen && (
                <button className="menu-toggle" onClick={toggleMenu}>
                    <FaChevronRight />
                </button>
            )}

            <div className={`menu-overlay ${isOpen ? 'active' : ''}`} onClick={closeMenu}></div>

            <nav className={`bar-menu ${isOpen ? 'open' : ''}`}>
                <div className="menu-logo">
                    <div className="logo-wrapper">
                        <DiDotnet />
                    </div>
                    <span className="logo-text">Painel</span>
                    <button className="close-button" onClick={closeMenu}>
                        <MdClose />
                    </button>
                </div>

                <div className="menu-content">
                    <div className="menu-section">
                        <div className="section-label">Principal</div>

                        {renderMenuItem('dashboard', <MdDashboard />, 'Dashboard')}
                        {renderMenuItem('analytics', <MdAnalytics />, 'Análise')}
                        {renderMenuItem('load', <FaCloudUploadAlt />, 'Carregar Dados')}
                        {renderMenuItem('ticketUpdates', <BsClipboard2DataFill />, 'Atualizações de Tickets')}
                        {renderMenuItem('export', <BsFillFileEarmarkSpreadsheetFill />, 'Exportar')}
                        {renderMenuItem(
                            'notifications',
                            <MdNotifications />,
                            'Notificações',
                            unreadCount > 0 && (
                                <div className="badge-bg">
                                    <span className="badge">
                                        {unreadCount > 99 ? '99+' : unreadCount}
                                    </span>
                                </div>
                            )
                        )}
                    </div>

                    <div className="menu-divider"></div>

                    <div className="menu-section">
                        <div className="section-label">Configurações</div>

                        {renderMenuItem('profile', <MdPerson />, 'Perfil')}
                        {renderMenuItem('settings', <MdSettings />, 'Configurações')}
                        {renderMenuItem('logout', <MdLogout />, 'Sair')}
                    </div>
                </div>

                <div className="menu-footer">
                    <div className="user-info" onClick={() => navigate("/profile")}>
                        <div className="user-avatar">
                            <MdPerson />
                        </div>
                        <div className="user-details">
                            <span className="user-name">
                                {loggedInUser?.nomeCompleto || "Usuário"}
                            </span>
                            <span className="user-role">
                                {permissions?.name || "Carregando..."}
                            </span>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}